import React, { memo } from "react";
import { Card } from "antd";
import ModuleTabContent from "components/layout-components/ModuleTabContent";
import ModuleSubTabs from "components/layout-components/ModuleSubTabs";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import Dashboard from "./Dashboard";
import TrackingReport from "./TrackingReport";
import AuditRegister from "./AuditRegister";
import Reports from "./Reports";
import Questions from "./Questions";
import FacilitySetup from "./FacilitySetup";

// All 8 screens from MajesticERP-CleaningAuditWeb's own nav (client/src/App.js)
// are represented here. State, Observation and Facility Questions share one
// Questions screen in three modes: observation questions are a separate,
// optional list with their own API (the old app's routes.js pointed that
// route at the state questions screen by mistake), and facility questions
// show only the chosen facility's own, also optional, questions. Facility
// Setup covers Floor/Area/Room management; its Excel bulk-upload feature is a
// separate, not-yet-covered piece.
// Header tabs (titles/order) are in NavigationConfig's "cleaning-audit" entry.
// The three question lists and the two audit screens are grouped under one
// header tab each, with in-page tabs inside the card (same layout as
// Employee Connect); each in-page tab has its own address.
const BASE = `${APP_PREFIX_PATH}/cleaning-audit`;

const screens = {
  dashboard: <Dashboard />,
  "facility-setup": <FacilitySetup />,
  questions: (
    <Card bodyStyle={{ padding: "24px 28px" }}>
      <ModuleSubTabs
        basePath={`${BASE}/questions`}
        items={[
          { key: "state", label: "State Questions", render: () => <Questions /> },
          { key: "observation", label: "Observation Questions", render: () => <Questions observation /> },
          { key: "facility", label: "Facility Questions", render: () => <Questions withFacility /> },
        ]}
      />
    </Card>
  ),
  audits: (
    <Card bodyStyle={{ padding: "24px 28px" }}>
      <ModuleSubTabs
        basePath={`${BASE}/audits`}
        items={[
          { key: "tracking", label: "Audit Report Tracking", render: () => <TrackingReport /> },
          { key: "register", label: "Audit Register", render: () => <AuditRegister /> },
        ]}
      />
    </Card>
  ),
  reports: <Reports />,
};

const CleaningAudit = () => <ModuleTabContent navKey="cleaning-audit" screens={screens} />;

export default memo(CleaningAudit);
